module.exports = __webpack_public_path__ + "static/Phoenix-497a20c914621e9da85a3d9b8091696c.jpg";